const numbers = [
  { text: "+500 Alunos" },
  { text: "+25 Matérias Oferecidas" },
  { text: "+30 Escolas de Campinas" },
];

export default numbers;
